const coursetypes = {
	title: "Course Types",
	new_coursetype: "New Course Type",
	edit_coursetype: "Edit Course Type: {name}",
	view_coursetype: "View Course Type: {name}",
	list_title: "List of Course Types",
	list_subtitle: "Manage Course Types",
	create_title: "Create New Course Type",
	update_title: "Update Course Type",
	details_title: "Course Type Details",
	id: "ID",
	name: "Name",
	category: "Category",
	status: "Status",
	code: "Code",
	teaching_plan: "Teaching Plan",
	teaching_material: "Teaching Materials",
};
export default coursetypes;